import SyncableModel from './SyncableModel';

export default class Notification extends SyncableModel {
  static name = 'Notification'

  _fillable = [
    "id",
    "type",
    "notifiable_id",
    "notifiable_type",
    "data",
    "read_at",
    "created_at",
    "updated_at"
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    unread: "boolean",
    notifiable_id: "integer",
    data: "object"
  }

  static endpoint = '/notifications'

  static online = true
}
